import OrganizersEdit from "./organizersEdit";

export default OrganizersEdit;